<div #aiDialogue>
    <router-outlet></router-outlet>
</div>

@if (tp.popBox.status) {
    <pop-inform [type]="tp.popBox.type" [pos]="tp.popBox.top" [direction]="tp.popBox.direc">
        {{ tp.popBox.text }}
    </pop-inform>
    @if(tp.popBox.type === 'loading') { <div class="mask"></div> }
}